const ROWS = [0, 1, 2, 3, 4, 5];

export function ListSkeleton() {
  return (
    <div aria-hidden="true">
      {ROWS.map((i) => (
        <div
          key={i}
          className="flex h-row items-center gap-3 border-b border-surface-border px-gutter"
        >
          <div className="h-5 w-5 shrink-0 animate-pulse rounded bg-surface-border" />
          <div className="h-3.5 flex-1 animate-pulse rounded bg-surface-border" />
          <div className="hidden h-3.5 w-40 animate-pulse rounded bg-surface-border sm:block" />
          <div className="hidden h-3.5 w-24 animate-pulse rounded bg-surface-border sm:block" />
          <div className="w-8 shrink-0" />
        </div>
      ))}
    </div>
  );
}
